export const CHANGE_EMAIL_REQUEST = "CHANGE_EMAIL_REQUEST"
export const CHANGE_EMAIL_SUCCESS = "CHANGE_EMAIL_SUCCESS"
export const CHANGE_EMAIL_FALUIRE = "CHANGE_EMAIL_FALUIRE"
